import type { Component } from 'solid-js'
import { Circle } from 'styled-system/jsx'
import { AppTooltip } from './AppTooltip'

export const Rank: Component<{ rank: string, dimensions?: string }> = (props) => {
	return (
    <AppTooltip content={props.rank.replace('_', ' ')}>
      <Circle
        height={props?.dimensions || '16px'}
        width={props?.dimensions || '16px'}
        backgroundSize='cover'
        style={{
          'background-image': `url(/rank/${props.rank}.png)`,
        }}
        />
    </AppTooltip>
	)
}
